var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.needToolbar)?_c('toolbar-nav'):_vm._e(),_c('loading'),_c('v-content',{attrs:{"id":"main-app"}},[_c('router-view')],1),_c('snackbar'),_c('bottom-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }